export const defaultState = {
    route: null,
    country: null,
    inquiry: null,
    mailchimpSignup: null,
    phoneValid: false,
    emailValid: false,
    travelData: {
        user:{ 
            firstName: '', 
            lastName: '', 
            email: '', 
            phone: '', 
            gender: ''
        }, 
        groupSize:{adults: 1, children: 0, infants: 0}, 
        duration: 14, 
        month: '', 
        year: '', 
        fullMonthName: '', 
        budget: null, 
        tos: false, 
        tour: null, 
        destinationCountry: null, 
        qualityValue: 50,
        inquiryType: '',
    },
    pending: false,
    error: null,
};

// create a deep clone of the defaultState to avoid mutations writing to the defaultState
export const state = () => ({
    ...JSON.parse(JSON.stringify(defaultState))
});
